/**
 * The phone drawn around a framed preview: the body behind the screen, and the Dynamic Island and
 * home indicator over it (US 359).
 *
 * Siblings of the preview iframe, never a wrapper around it: the published page restyles its one
 * iframe rather than remounting it, so the visitor keeps whatever screen they had reached. Both
 * overlays ignore the pointer, so taps and hot-edit selection reach the app underneath.
 */

import React from 'react';
import type { DeviceFrameLayout } from './devices';

/** Rendered before the iframe, so the screen sits on top of the bezel. */
export function DeviceBody({ layout }: { layout: DeviceFrameLayout }) {
  if (layout.bodyRadius == null) return null;
  return (
    <div
      aria-hidden
      className="pointer-events-none absolute left-0 top-0 bg-neutral-900 shadow-2xl ring-1 ring-black/40"
      style={{
        width: layout.outer.width,
        height: layout.outer.height,
        borderRadius: layout.bodyRadius,
      }}
    />
  );
}

/** Rendered after the iframe, so the island and the home indicator sit on the screen. */
export function DeviceScreenHardware({ layout }: { layout: DeviceFrameLayout }) {
  return (
    <>
      {layout.island && (
        <div
          aria-hidden
          className="pointer-events-none absolute rounded-full bg-black"
          style={layout.island}
        />
      )}
      {layout.homeIndicator && (
        // Dark on a light app and light on a dark one, as the real indicator is.
        <div
          aria-hidden
          className="pointer-events-none absolute rounded-full bg-white mix-blend-difference"
          style={{ ...layout.homeIndicator, opacity: 0.55 }}
        />
      )}
    </>
  );
}
